<script lang="ts">
	export let active = false;
	export let hover = false;

</script>

<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20.5 20.501">
	<g>
		<g>
			<g>
				<path
					class:active
					class:hover
					d="m194.288 355.969-7.686.008a.789.789 0 0 1-.8-.773v-7.738a.789.789 0 0 1 .8-.773l7.686-.008a.789.789 0 0 1 .8.773v7.094a.2.2 0 0 1-.39 0v-7.094a.406.406 0 0 0-.413-.4l-7.686.008a.406.406 0 0 0-.414.4v7.734a.406.406 0 0 0 .413.4l7.686-.008a.406.406 0 0 0 .413-.4v-.77a.2.2 0 0 1 .39 0v.77a.789.789 0 0 1-.799.777z"
					transform="translate(-185.549 -346.435)" />
			</g>
		</g>
		<g>
			<g>
				<path
					class:active
					class:hover
					d="m194.288 355.969-7.686.008a.789.789 0 0 1-.8-.773v-7.738a.789.789 0 0 1 .8-.773l7.686-.008a.789.789 0 0 1 .8.773v7.094a.2.2 0 0 1-.39 0v-7.094a.406.406 0 0 0-.413-.4l-7.686.008a.406.406 0 0 0-.414.4v7.734a.406.406 0 0 0 .413.4l7.686-.008a.406.406 0 0 0 .413-.4v-.77a.2.2 0 0 1 .39 0v.77a.789.789 0 0 1-.799.777z"
					transform="translate(-185.549 -335.726)" />
			</g>
		</g>
		<g>
			<g>
				<path
					class:active
					class:hover
					d="m194.288 355.969-7.686.008a.789.789 0 0 1-.8-.773v-7.738a.789.789 0 0 1 .8-.773l7.686-.008a.789.789 0 0 1 .8.773v7.094a.2.2 0 0 1-.39 0v-7.094a.406.406 0 0 0-.413-.4l-7.686.008a.406.406 0 0 0-.414.4v7.734a.406.406 0 0 0 .413.4l7.686-.008a.406.406 0 0 0 .413-.4v-.77a.2.2 0 0 1 .39 0v.77a.789.789 0 0 1-.799.777z"
					transform="translate(-185.549 -346.435)" />
			</g>
		</g>
		<g>
			<g>
				<path
					class:active
					class:hover
					d="m194.288 355.969-7.686.008a.789.789 0 0 1-.8-.773v-7.738a.789.789 0 0 1 .8-.773l7.686-.008a.789.789 0 0 1 .8.773v7.094a.2.2 0 0 1-.39 0v-7.094a.406.406 0 0 0-.413-.4l-7.686.008a.406.406 0 0 0-.414.4v7.734a.406.406 0 0 0 .413.4l7.686-.008a.406.406 0 0 0 .413-.4v-.77a.2.2 0 0 1 .39 0v.77a.789.789 0 0 1-.799.777z"
					transform="translate(-185.549 -335.726)" />
			</g>
		</g>
		<g>
			<g>
				<path
					class:active
					class:hover
					d="m194.288 355.969-7.686.008a.789.789 0 0 1-.8-.773v-7.738a.789.789 0 0 1 .8-.773l7.686-.008a.789.789 0 0 1 .8.773v7.094a.2.2 0 0 1-.39 0v-7.094a.406.406 0 0 0-.413-.4l-7.686.008a.406.406 0 0 0-.414.4v7.734a.406.406 0 0 0 .413.4l7.686-.008a.406.406 0 0 0 .413-.4v-.77a.2.2 0 0 1 .39 0v.77a.789.789 0 0 1-.799.777z"
					transform="translate(-174.841 -346.435)" />
			</g>
		</g>
		<g>
			<g>
				<path
					class:active
					class:hover
					d="m194.288 355.969-7.686.008a.789.789 0 0 1-.8-.773v-7.738a.789.789 0 0 1 .8-.773l7.686-.008a.789.789 0 0 1 .8.773v7.094a.2.2 0 0 1-.39 0v-7.094a.406.406 0 0 0-.413-.4l-7.686.008a.406.406 0 0 0-.414.4v7.734a.406.406 0 0 0 .413.4l7.686-.008a.406.406 0 0 0 .413-.4v-.77a.2.2 0 0 1 .39 0v.77a.789.789 0 0 1-.799.777z"
					transform="translate(-174.841 -335.726)" />
			</g>
		</g>
	</g>
</svg>

<style lang="scss">
	path {
		fill: #bcbfc3;
		stroke: #bcbfc3;
		stroke-width: 0.5px;
		transition: all 0.5s;
		&.active {
			fill: var(--signature-blue) !important;
			stroke: var(--signature-blue) !important;
		}
		&.hover {
			fill: var(--default-hover-btn-1);
			stroke: var(--default-hover-btn-1);
		}
	}

</style>
